var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',_vm._g(_vm._b({staticClass:"admin-checkbox",attrs:{"color":_vm.iconColor,"size":_vm.size,"disabled":_vm.disabled}},'v-icon',Object.assign({}, _vm.$attrs, _vm.$props),false),_vm.$listeners),[_vm._v(_vm._s(_vm.iconName))])}
var staticRenderFns = []

export { render, staticRenderFns }